var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"TopicHead"},[_vm._v("TEXT")]),_c('h2',{staticClass:"Topic"},[_vm._v("TEXT")]),_c('h2',{staticClass:"Topic"},[_vm._v("TEXT")]),_c('h2',{staticClass:"Topic"},[_vm._v("TEXT")])])
}]

export { render, staticRenderFns }